<template>
  <AnalyticsWidget
    title="Production Panel Schedule"
    subTitle="Breakdown of panels due dates to complete production"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <ChartBar
      :series="panelScheduleChartData.series"
      :xAxis="panelScheduleChartData.xAxis"
      :yAxis="panelScheduleChartData.yAxis"
      :legend="panelScheduleChartData.legend"
      :options="panelScheduleChartData.options"
      />
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'

import ChartBar from '@/components/charts/chartBar'

export default {
  name: 'ProductionScheduleWidget',
  components: {
    AnalyticsWidget,
    ChartBar
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
  },
  data() {
    return {
      loading: true,
      panelDueList: {},
      panelScheduleChartData: {
        series: [],
        xAxis: {},
        yAxis: {},
        legend: {},
        options: {}
      }
    }
  },
  watch: {
  },
  mounted() {
    this.loading = true
    this.requestChartData()

    this.subscribeEndpoint('/production/panelschedule', () => {
      this.requestChartData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/production/panelschedule')
  },
  methods: {
    requestChartData() {
      this.$apiService.analyticsService.getProductionPanelDueData()
      .then(response => {
        this.panelDueList = response.data
        let chartData = this.panelDueList

        var currentDate = moment()
        var startOfDay = moment().local().startOf('day')

        this.panelScheduleChartData.legend = {
          data: []
        }
        this.panelScheduleChartData.xAxis = {
          data: chartData.map(chartEntry => moment(chartEntry.dayProductionDue).format('DD MMM'))
        }
        this.panelScheduleChartData.yAxis = [
          {
            type: 'value',
            minInterval: 1,
            axisLabel: {
              formatter: (value) => {
                return value
              }
            }
          },
        ]
        this.panelScheduleChartData.series = []
        this.panelScheduleChartData.series.push({
          type: 'bar',
          name: 'Panel Count',
          data: chartData.map(chartEntry => {
            // Colours based on overdue, today, tomorrow +
            var overdueColour = '#EE6666'
            var todayColour = '#FAC858'
            var otherColour = '#91CC75'

            let prodDay = moment(chartEntry.dayProductionDue)
            let colour = otherColour

            if(prodDay.isBefore(startOfDay))
              colour = overdueColour
            else if(prodDay.isSame(currentDate, 'day'))
              colour = todayColour

            return {
              value: chartEntry.totalPanelCount,
              itemStyle: { color: colour }
            }
          })
        })

      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
        console.error(err)
      })
    },
    
  }
}
</script>